import { DinamikBilesen } from '@service/fikoyt-ui/decorators/dinamik-bilesen';
import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GameCardBase, GC_BASE_CSS } from '@/src/app/uygulamalar/hmi-pano/pano/game-card-base';
import { paramDeger } from '@/src/app/shared/utils/param-deger.utils';
import { CamCncEditComponent } from './cam-cnc-edit.component';
import { CamCncKartSadeComponent } from './cam-cnc-kart-sade.component';

const DURUM_RENK: Record<string, string> = { 'Bekliyor': '#94a3b8', 'İşleniyor': '#f59e0b', 'Tamamlandı': '#22c55e', 'Red': '#ff4d4f', 'Arıza': '#cf1322' };
const DURUM_RGB: Record<string, string> = { 'Bekliyor': '148,163,184', 'İşleniyor': '245,158,11', 'Tamamlandı': '34,197,94', 'Red': '255,77,79', 'Arıza': '207,19,34' };

@Component({
  selector: 'cam-cnc-kart',
  standalone: true,
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="gc gc--cam-cnc" [style.--accent]="renk()" [style.--accent-rgb]="rgb()" (mousemove)="mouseMove($event)" (mouseleave)="mouseLeave()" [ngStyle]="kartStil">
      <div class="gc-canli-bg"></div><div class="gc-parlak-kenar"></div>
      <div class="gc-kose gc-kose--sol-ust"></div><div class="gc-kose gc-kose--sag-ust"></div><div class="gc-kose gc-kose--sol-alt"></div><div class="gc-kose gc-kose--sag-alt"></div>
      <div class="gc-kose-ic gc-kose-ic--sol-ust"></div><div class="gc-kose-ic gc-kose-ic--sag-ust"></div><div class="gc-kose-ic gc-kose-ic--sol-alt"></div><div class="gc-kose-ic gc-kose-ic--sag-alt"></div>
      <div class="gc-rarity-serit"></div><div class="gc-ic-glow"></div><div class="gc-desen"></div><div class="gc-shimmer"></div><div class="gc-holo"></div>
      <div class="gc-kenar-glow" [style.background]="kenarGlow"></div>
      <div class="gc-icerik" [class.cc-acil]="d('oncelik') === 'Acil'">
        @if (d('oncelik') === 'Acil') { <div class="cc-acil-banner"><span class="cc-acil-dot"></span> 🚨 ACİL İŞ</div> }
        <div class="gc-hud-baslik">⚙️ CNC İŞLEM</div>
        <div class="cc-baslik">{{ d('tezgah') || 'Tezgah' }}</div>
        @if (d('oncelik') && d('oncelik') !== 'Normal' && d('oncelik') !== 'Acil') {
          <div class="cc-oncelik" [style.color]="d('oncelik') === 'Yüksek' ? '#f59e0b' : '#94a3b8'">⚡ {{ d('oncelik') }}</div>
        }
        <div class="cc-durum-badge" [style.background]="'rgba('+rgb()+',.25)'" [style.color]="renk()" [style.border-color]="'rgba('+rgb()+',.5)'" [style.box-shadow]="'0 0 10px rgba('+rgb()+',.2)'">{{ sonDurum() }}</div>
        <div class="gc-xp-bar"><div class="gc-xp-dolgu" [style.width.%]="gorunur() ? ilerleme() : 0"></div></div>
      </div>
    </div>
  `,
  styles: [GC_BASE_CSS, `
    .cc-baslik { font-size: 14px; font-weight: 700; color: var(--py-metin, #e2e8f0); white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
    .cc-oncelik { font-size: 10px; font-weight: 700; letter-spacing: .05em; }
    .cc-durum-badge { display: inline-block; padding: 3px 12px; border-radius: 4px; font-size: 10px; font-weight: 800; letter-spacing: .08em; text-transform: uppercase; border: 1.5px solid; margin-top: 4px; backdrop-filter: blur(4px); }
    .cc-acil { border-left: 3px solid #ef4444; }
    .cc-acil-banner { display:flex; align-items:center; gap:6px; padding:4px 0; margin-bottom:2px; font-size:10px; font-weight:900; color:#ef4444; }
    .cc-acil-dot { width:6px; height:6px; border-radius:50%; background:#ef4444; animation:acil-pulse .5s ease-in-out infinite; }
    @keyframes acil-pulse { 0%,100%{ opacity:1; transform:scale(1); } 50%{ opacity:.4; transform:scale(1.3); } }
  `],
})
export class CamCncKartComponent extends GameCardBase {
  parametreler = input<any>();
  _hesap = input<any>();
  constructor() { super(); }
  d(ismi: string) { return paramDeger(this.parametreler()?.ek, ismi); }
  sonDurum = computed(() => this._hesap()?.sonDurum || this.d('durum') || 'Bekliyor');
  renk = computed(() => DURUM_RENK[this.sonDurum()] || '#94a3b8');
  rgb = computed(() => DURUM_RGB[this.sonDurum()] || '148,163,184');
  ilerleme = computed(() => this.sonDurum() === 'Tamamlandı' ? 100 : this.sonDurum() === 'İşleniyor' ? 60 : 10);
}

@DinamikBilesen({
  id: 'cam-cnc-islem',
  baslik: 'CNC İşlem',
  aciklama: 'CNC işlem takibi',
  ikon: 'tool',
  kategori: 'cam-isleme',
})
class CamCnc {
  paylas_kutusu = CamCncEditComponent;
  paylasilmis_kart = CamCncKartComponent;
  paylasilmis_kart_sade = CamCncKartSadeComponent;

  hesaplamalar = {
    prepipe: [
      { $lookup: { from: 'hareketler', let: { pid: '$_id' }, pipeline: [
        { $match: { $expr: { $eq: ['$_uid', '$$pid'] }, silindi: { $ne: true } } },
        { $lookup: { from: 'hareketler', localField: 'veri.icerikler', foreignField: '_id', as: 'ic' } },
        { $unwind: { path: '$ic', preserveNullAndEmptyArrays: false } },
        { $match: { 'ic.ek._secilenSetId': 'cam.cnc.durum' } },
        { $sort: { _id: -1 } },
        { $limit: 1 }
      ], as: '_alt' } },
      { $addFields: {
        '_hesap.sonDurum': { $ifNull: [{ $arrayElemAt: ['$_alt.ic.ek.durum', 0] }, null] },
      }},
      { $project: { _alt: 0 } }
    ],
  };
}
